/**
 * Section: Results in Practice Subtle Image Parallax (custom-results-practice.js)
 */

(function () {
  'use strict';

  function initResultsParallax() {
    const card = document.querySelector('.juli-results-showcase-box');
    const img = document.querySelector('.juli-results-showcase-img');
    if (!card || !img) return;

    let rafId = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    let targetScale = 1.01;
    let currentScale = 1.01;
    let isHovered = false;

    function render() {
      // Smooth damping interpolation
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      currentScale += (targetScale - currentScale) * 0.08;

      const moveX = -currentX * 18; // Subtle parallax pan in pixels
      const moveY = -currentY * 18;

      img.style.transform = `scale(${currentScale.toFixed(4)}) translate3d(${moveX.toFixed(2)}px, ${moveY.toFixed(2)}px, 0)`;

      // Stop loop when fully settled back to resting scale
      if (!isHovered && Math.abs(currentX) < 0.0005 && Math.abs(currentY) < 0.0005 && Math.abs(currentScale - 1.01) < 0.0005) {
        currentX = 0;
        currentY = 0;
        currentScale = 1.01;
        img.style.transform = 'scale(1.01) translate3d(0px, 0px, 0)';
        rafId = null;
        return;
      }

      rafId = requestAnimationFrame(render);
    }

    card.addEventListener('mouseenter', () => {
      isHovered = true;
      targetScale = 1.03; // Exact 103% zoom on hover
      if (!rafId) {
        rafId = requestAnimationFrame(render);
      }
    });

    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      targetX = (e.clientX - rect.left) / rect.width - 0.5; // -0.5 to 0.5
      targetY = (e.clientY - rect.top) / rect.height - 0.5; // -0.5 to 0.5
    });

    card.addEventListener('mouseleave', () => {
      isHovered = false;
      targetX = 0;
      targetY = 0;
      targetScale = 1.01; // Smoothly return back to resting scale 101%
      if (!rafId) {
        rafId = requestAnimationFrame(render);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResultsParallax);
  } else {
    initResultsParallax();
  }
})();
